import axios from 'axios';

import {  Link } from 'react-router-dom';
import Swal from 'sweetalert2'
import {
  CLIENTS_LOADING,
  GET_PARTICIPANTS,
  GET_PARTICIPANT_OWN_STATS,
  GET_PARTICIPANT_COUNT_BY_CONFERENCE,
  GET_PARTICIPANTS_STATS,
  GET_NUMBER_OF_PARTICIPANTS_PER_CONFERENCE,
  GET_NUMBER_OF_PARTICIPANTS_PER_CONFERENCE_BY_DAY,
  GET_CONFERENCE_STATUS,
  GET_CONFERENCE,
  GET_NUMBER_OF_PARTICIPANTS_ALL,
  CONFERENCE_LOADING,
  GET_CONFERENCES,
  GET_ERRORS,
  GET_USERS,
  GET_CONFERENCE_LIST
} from './types';

// Register Student
export const registerStudent = (userData) => dispatch => {
  axios
    .post('/api/clients/registerStudent', userData)
    .then(res => {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Uspešno ste registrovali studenta!',
        showConfirmButton: false,
        timer: 3000
      })
      setTimeout(function () {
        window.location.reload()
      }, 3000);
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Greška, pokušajte ponovo! Moguće da u bazi već postoji registrovan mejl.',
        showConfirmButton: false,
        timer: 3000
      })
      setTimeout(function () {
        window.location.reload()
      }, 3000);
    })
};
//Send admins credentials on mail when register
export const emailAdminRegistration = (userData) => dispatch => {
  axios
    .post('/api/clients/emailAdminRegistration', userData)
    .then(res => {
      console.log('mail sent');
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    })
};

// Register Admin
export const registerAdmin = (userData) => dispatch => {
  axios
    .post('/api/clients/registerAdmin', userData)
    .then(res => {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Uspešno ste registrovali administratora!',
        showConfirmButton: false,
        timer: 3000
      })

      setTimeout(function () {
        window.location.reload()
      }, 3000);
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Greška, pokušajte ponovo! Moguće da u bazi već postoji registrovan mejl.',
        showConfirmButton: false,
        timer: 3000
      })
      setTimeout(function () {
        window.location.reload()
      }, 3000);
    })
};

// Create Client
export const createClient = (newParticipant) => dispatch => {
  axios
    .post(`/api/clients/newParticipant`, newParticipant)
    .then(res => {
      window.location.reload();
      console.log(res);
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
      console.log(err.response.data.student);
      if( err.response.data.student == 'Ovaj korisnik je već registrovan za ovo predavanje' ) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Učesnik je već prokucan za ovo predavanje.',
        });
      }
      else if(err.response.data.student == 'Korisnik nije na spisku') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Učesnik nije na spisku registrovanih.',
        });
      }
      else if(err.response.data.student == 'Predavanje nije otvoreno') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Predavanje nije započeto',
        });
      }
    })
};
// Get student attendance
export const getParticipants = (conference) => dispatch => {
  axios
    .get(`/api/clients/getParticipants/${conference}`)
    .then(res => {
      dispatch({
        type: GET_PARTICIPANTS,
        payload: res.data
      })
    })
    .catch(err => {
      dispatch({
        type: GET_PARTICIPANTS,
        payload: null
      })
    })
};
// get list of users 
export const getUsers = () => dispatch => {
  axios
    .get(`/api/clients/getUsers/`)
    .then(res => {
      dispatch({
        type: GET_USERS,
        payload: res.data
      })
    })
    .catch(err => {
      dispatch({
        type: GET_USERS,
        payload: null
      })
    })
};
// get info on completed conferences 
export const getStudentStats = (email) => dispatch => {
  axios
    .get(`/api/clients/getStudentStats/${email}`)
    .then(res => {
      dispatch({
        type: GET_PARTICIPANT_OWN_STATS,
        payload: res.data
      })
    })
    .catch(err => {
      dispatch({
        type: GET_PARTICIPANT_OWN_STATS,
        payload: null
      })
    })
};

// get info on completed conferences 
export const getNumOfParticipants = (conference) => dispatch => {
  axios
    .get(`/api/clients/getNumOfParticipants/${conference}`)
    .then(res => {
      dispatch({
        type: GET_PARTICIPANT_COUNT_BY_CONFERENCE,
        payload: res.data
      })
    })
    .catch(err => {
      dispatch({
        type: GET_PARTICIPANT_COUNT_BY_CONFERENCE,
        payload: null
      })
    })
};

// get all student stats 
export const getStudentStatsAdminView = () => dispatch => {
  axios
    .get(`/api/clients/getParticipantStats/`)
    .then(res => {
      dispatch({
        type: GET_PARTICIPANTS_STATS,
        payload: res.data
      })
    })
    .catch(err => {
      dispatch({
        type: GET_PARTICIPANTS_STATS,
        payload: null
      })
    })
};

// get number of students per conference
export const getNumberOfStudentsPerConference = () => dispatch => {
  axios
    .get(`/api/clients/getNumberOfStudentsPerConference/`)
    .then(res => {
      dispatch({
        type: GET_NUMBER_OF_PARTICIPANTS_PER_CONFERENCE,
        payload: res.data
      })
    })
    .catch(err => {
      dispatch({
        type: GET_NUMBER_OF_PARTICIPANTS_PER_CONFERENCE,
        payload: null
      })
    })
};
// get number of students per conference
export const getNumberOfStudentsPerConferenceByDay = () => dispatch => {
  axios
    .get(`/api/clients/getNumberOfStudentsPerConferenceByDay/`)
    .then(res => {
      dispatch({
        type: GET_NUMBER_OF_PARTICIPANTS_PER_CONFERENCE_BY_DAY,
        payload: res.data
      })
    })
    .catch(err => {
      dispatch({
        type: GET_NUMBER_OF_PARTICIPANTS_PER_CONFERENCE_BY_DAY,
        payload: null
      })
    })
};

//get conference status
export const getConferenceStatus = () => dispatch => {
  axios
    .get(`/api/clients/getConferenceStatus/`)
    .then(res => {
      dispatch({
        type: GET_CONFERENCE_STATUS,
        payload: res.data
      })
    }).catch(err => {
      dispatch({
        type: GET_CONFERENCE_STATUS,
        payload: null
      })
    })
};

//change conference status
export const getChangeConferenceStatus = (_id, statusConference) => dispatch => {
  dispatch(setClientsLoading());
  axios
    .get(`/api/clients/getChangeConferenceStatus/${_id}/${statusConference}`)
    .then(res => {
      window.location.reload();
    })
    .catch(err => {
      window.location.reload();
    })
}

// Get ceonference by id
export const getConferenceById = _id => dispatch => {
  dispatch(setClientsLoading());
  axios
    .get(`/api/clients/${_id}`)
    .then(res =>
      dispatch({
        type: GET_CONFERENCE,
        payload: res.data
      })
    )
    .catch(err =>
      dispatch({
        type: GET_CONFERENCE,
        payload: null
      })
    );
};
// get number of participants all 
export const getNumberOfParticipantsAll = () => dispatch => {
  dispatch(setClientsLoading());
  axios
    .get(`/api/clients/getNumberOfParticipantsAll/`)
    .then(res => {
      dispatch({
        type: GET_NUMBER_OF_PARTICIPANTS_ALL,
        payload: res.data
      })
    })
    .catch(err =>
      dispatch({
        type: GET_NUMBER_OF_PARTICIPANTS_ALL,
        payload: null
      })
    );

}

// changes details of conference
export const changeConferenceDetails = (conference) => dispatch => {
  dispatch(setClientsLoading())
  axios
    .post(`/api/clients/changeConferenceDetails/`, conference)
    .then(res => {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Uspešno ste dodali podatke o predavanju!',
        showConfirmButton: false,
        timer: 3000
      })
      setTimeout(function () {
        window.location.reload()
      }, 3000);
    })
    .catch(err => {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Greška, pokušajte ponovo!',
        showConfirmButton: false,
        timer: 3000
      })
      setTimeout(function () {
        window.location.reload()
      }, 3000);
    })
}

// changes details of conference
export const deleteConference = (_id) => dispatch => {
  dispatch(setClientsLoading())
  axios
    .post(`/api/clients/deleteConference/${_id}`)
    .then(res => {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Obrisali ste predavanje',
        showConfirmButton: false,
        timer: 3000
      })
      setTimeout(function () {
        window.location.reload()
      }, 3000);
    })
    .catch(err => {
      console.log('nope')
      alert('2')
    })
}
// Deleting from Users model
export const deleteUsers = (_id) => dispatch => {
  dispatch(setClientsLoading())
  axios
    .post(`/api/clients/deleteUsers/${_id}`)
    .then(res => {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Uspešno ste uklonili učesnika iz baze',
        showConfirmButton: false,
        timer: 3000
      })
      setTimeout(function () {
        window.location.reload()
      }, 3000);
    })
    .catch(err => {
      console.log('nope')
      alert('2')
    })
}

// get list of users 
export const getConferences = () => dispatch => {
  axios
    .get(`/api/clients/getConferences/`)
    .then(res => {
      dispatch({
        type: GET_CONFERENCE_LIST,
        payload: res.data
      })
    })
    .catch(err => {
      dispatch({
        type: GET_CONFERENCE_LIST,
        payload: null
      })
    })
};

// gets all conferences for display and shit 
export const getAllConferences = () => dispatch => {
  dispatch(setConferenceLoading())
  axios
    .get(`/api/clients/getAllConferences/`)
    .then(res => {
      dispatch({
        type: GET_CONFERENCES,
        payload: res.data
      })
    })
    .catch(err =>
      dispatch({
        type: GET_CONFERENCES,
        payload: null
      })
    );
}

// conference loading
export const setConferenceLoading = () => {
  return {
    type: CONFERENCE_LOADING
  };
};

// Profile loading
export const setClientsLoading = () => {
  return {
    type: CLIENTS_LOADING
  };
};
